import { defineComponent as _defineComponent } from 'vue'
import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vShow as _vShow, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import StatsInventoryViewVue from './InventoryViews/StatsInventoryView.vue.vue';
    import StatsSalesView from './SalesViews/StatsSalesView.vue';
    import StatsShoppingView from './ShoppingViews/StatsShoppingView.vue';

    import { ref } from 'vue';
    
export default /*#__PURE__*/_defineComponent({
  __name: 'BoardView',
  setup(__props) {

    const inventario = ref(true) 
    const ventas = ref(true)
    const compras = ref(true)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("label", null, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inventario).value = $event))
        }, null, 512), [
          [_vModelCheckbox, inventario.value]
        ]),
        _createTextVNode(" inventario")
      ]),
      _createElementVNode("label", null, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((ventas).value = $event))
        }, null, 512), [
          [_vModelCheckbox, ventas.value]
        ]),
        _createTextVNode(" ventas")
      ]),
      _createElementVNode("label", null, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((compras).value = $event))
        }, null, 512), [
          [_vModelCheckbox, compras.value]
        ]),
        _createTextVNode(" compras")
      ])
    ]),
    _createElementVNode("div", null, [
      _withDirectives(_createVNode(StatsInventoryViewVue, null, null, 512), [
        [_vShow, inventario.value]
      ]),
      _withDirectives(_createVNode(StatsSalesView, null, null, 512), [
        [_vShow, ventas.value]
      ]),
      _withDirectives(_createVNode(StatsShoppingView, null, null, 512), [
        [_vShow, compras.value]
      ])
    ])
  ], 64))
}
}

})